import { render } from "./LoadingLoad.vue?vue&type=template&id=206db492"
import script from "./LoadingLoad.vue?vue&type=script&lang=js"
export * from "./LoadingLoad.vue?vue&type=script&lang=js"

import "./LoadingLoad.vue?vue&type=style&index=0&id=206db492&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__